import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'tea-component';
import './index.scss';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';

import classnames from 'classnames';
const MODAL_SIZE_LARGE = 600;

export default function AllModelData(props: any) {
  const { visible, setVisible, width, children, title, footer, ...rest } = props;
  const { formatMessage, locale } = useIntlExtend();
  const [visibleModel, setVisibleModel] = useState(false);
  // 监听外部 visible 变化控制弹窗是否修改
  useEffect(() => {
    setVisibleModel(visible);
  }, [visible]);
  const handleToggleModal = () => {
    setVisibleModel(false);
    setVisible(false);
  };

  return (
    <Modal
      visible={visibleModel}
      caption={title}
      onClose={handleToggleModal}
      className={classnames('dbi-public-truedata-feedback-modal')}
      size={width || MODAL_SIZE_LARGE}
    >
      <Modal.Body {...rest}>
        {/* content */}
        {children}
      </Modal.Body>

      {footer && <Modal.Footer>{footer}</Modal.Footer>}
    </Modal>
  );
}
